// @flow
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FocusedImage from 'Components/FocusedImage';
import { Row, Col } from 'Components/Grid';
import AssetModel from 'Stores/AssetModel';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import CallToAction from 'Components/CallToAction';
import Button from 'Components/Button';
import ConsumptionData from 'Components/ConsumptionData';
import Typography, { headlinePropTypes } from 'Components/Typography';
import RichText from 'Components/RichText';
import { lowerCase6e } from 'Utils/special/lowerCaseSpecial';
import { getGivenBackground } from 'Utils/getColor';
import { ctaPropTypes } from 'Components/CallToAction';
import { withRouter } from 'react-router-dom';
import { Watch } from 'scrollmonitor-react';

const cx = classNames.bind(styles);

const HeroHeaderSmall = ({
  background = getGivenBackground('white'),
  backLink,
  bodyText,
  consumptionText,
  cta1,
  deeplinkId,
  headline,
  history,
  image,
  isInViewport = true,
  stopWatcher = () => {},
  subHeader,
  useFallbackImage = true,
}) => {
  const imageAsset = new AssetModel(image);

  const className = cx('hero-header-small', background, {
    inView: window.isPreview || isInViewport,
  });

  const onClick = () => {
    let href = '/';

    if (typeof backLink === 'string' && backLink.length > 0) {
      href = backLink;
    }

    history.push(href);
  };

  useEffect(() => {
    if (isInViewport) {
      stopWatcher();
    }
  }, [isInViewport, stopWatcher]);

  const renderPrimaryCta = (cta) => {
    return (
      <div className={styles.cta}>
        <CallToAction {...cta} />
      </div>
    );
  };

  return (
    <div className={className} id={deeplinkId}>
      {((useFallbackImage && !image) || image) && (
        <div className={styles.image}>
          <FocusedImage
            image={imageAsset}
            imageMobile={false}
            useThumb={imageAsset && imageAsset.shouldUseThumb()}
          />
        </div>
      )}
      {consumptionText && <ConsumptionData consumptionText={[consumptionText]} />}
      {backLink && (
        <div className={styles.backlink}>
          <Button
            onClick={onClick}
            ariaLabel={'zurück zur Übersicht navigieren'}
            label="← zurück"
            variant="secondary"
          />
        </div>
      )}

      <div className={cx('content')}>
        <Row align="center">
          <Col cols={12} m={10} l={8}>
            {subHeader && (
              <div
                className={styles.subtitle}
                dangerouslySetInnerHTML={{ __html: lowerCase6e(subHeader) }}
              />
            )}
            {headline && (
              <Typography.Headline
                levelVisually="h3"
                {...headline}
                className={styles.headline}
                additionalAriaLabelText={consumptionText}
              />
            )}
            {bodyText && <RichText content={bodyText} />}
            {cta1 && cta1.label && renderPrimaryCta(cta1)}
          </Col>
        </Row>
      </div>
    </div>
  );
};

HeroHeaderSmall.propTypes = {
  background: PropTypes.string,
  backLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  bodyText: PropTypes.string,
  consumptionText: PropTypes.string,
  cta1: PropTypes.shape(ctaPropTypes),
  deeplinkId: PropTypes.number,
  headline: PropTypes.shape(headlinePropTypes),
  history: PropTypes.object,
  image: PropTypes.object,
  isInViewport: PropTypes.bool,
  stopWatcher: PropTypes.func,
  subHeader: PropTypes.string,
  useFallbackImage: PropTypes.bool,
};

export default withRouter(Watch(HeroHeaderSmall));
